import { Component, OnInit, HostListener } from '@angular/core';
import { faUser, faLock } from '@fortawesome/free-solid-svg-icons';

import { CookieService } from 'ngx-cookie-service';

import { User, Header } from '../../classes';
import { LoginService } from '../../services/login.service';
import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  tk: any;
  login = false;
  business: boolean;
  profil: Array<any> = [];
  key: any;

  /* VARABLES */
  faUser = faUser;
  faLock = faLock;
  schema = '';
  user: User = {
    username: '',
    password: ''
  };

  header: Header = {};
  message = '';
  constructor(
    private loginService: LoginService,
    private cookie: CookieService,
    private globals: GlobalService
  ) {
    
  }

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) { 
    this.key = event.keyCode;
    if(event.keyCode === 13)
    document.getElementById('loginButton').click();
  }

  ngOnInit() {
    this.checkToken()
  }

  doLogin() {
    let userA = this.user.username.split('@'); // Splitto lo username per ottenere lo schema e lo username
    if (userA.length > 1) {
      this.schema = userA[0];
      this.user.username = userA[1];
      this.user.schema = userA[0]
      userA = [];
      this.loginService.doLogin(this.user).subscribe(
        res => {
          this.profil = res.profiles;
          if (this.profil.length > 1) {
            this.profil.forEach(element => {              
              if (element.isoperator == "Y") {
                element.description = element.name + " " + element.last_name;
              } else {
                if (element.business_name != null) {
                  element.description = element.business_name;
                } else {
                  element.description = element.cname + " " + element.clast_name
                }
              }
              this.tk = res.token;
              this.login = true;
            });
          } else {
            this.storageToken(res.token, this.user.rememberme);
            this.tk = this.globals.getToken();
            this.firstLogin(res.profiles[0].user_customer_profile_id);
          }
        },
        err => {
          this.message = "Errore durante il login";
        }
      )
    }
    else {
      if(this.schema){
        this.user.schema = this.schema;
        this.loginService.doLogin(this.user).subscribe(
          res => {
            this.profil = res.profiles;
            if (this.profil.length > 1) {
              this.profil.forEach(element => {
                if (element.isoperator == "Y") {
                  element.description = element.name + " " + element.last_name;
                } else {
                  if (element.business_name != null) {
                    element.description = element.business_name;
                  } else {
                    element.description = element.cname + " " + element.clast_name
                  }
                }
                this.tk = res.token;
                this.login = true;
              });
            } else {
              this.storageToken(res.token, this.user.rememberme);
              this.tk = this.globals.getToken();
              this.firstLogin(res.profiles[0].user_customer_profile_id);
            }
          },
          err => {
            this.message = "Errore durante il login";
          }
        )
      } else {
        this.message = "username non valido (azienda@username)";
      }
    }
  }

  firstLogin(cpid) {
    let tk = this.globals.tokenName;
    this.loginService.secondLogin(this.tk, cpid).subscribe(
      res => {
        this.storageToken(res.token, this.user.rememberme);
        this.setHeader(res.header);
        this.setUser(res.user);

        if(this.cookie.check(tk)){
          this.globals.checkToken(this.cookie.get(tk)).subscribe(
          res => {
            console.log("checkToken -> OK",res);
            if(this.globals.storagedUser.profile_id > 1){
              this.globals.goTo('operator')
            } else {
              this.globals.goToHome();
            }
            // this.globals.goToHome();
            
          },
          err => {
            console.error("checkToken -> ERR",err);
            
          })
        }
      },
      err => {
        console.error("KO", err);
        this.message = "Errore durante il secondo login"

      }
    )
  }

  checkToken(){
    let tk = this.globals.tokenName;    
    if(this.cookie.check(tk)){
      this.globals.checkToken(this.cookie.get(tk)).subscribe(
      res => {
        this.globals.goToHome();
      },
      err => {
        console.error("checkToken -> ERR",err);
      })
    }
  }

  storageToken(token: string, rememberme: boolean) {
    this.cookie.set(this.globals.tokenName, token);
  }

  setHeader(header) {
    this.globals.header = header;
    this.globals.header.forEach(component => {
      component.URL = this.getUrlByKey(component.key)
    })
    localStorage.setItem('header', JSON.stringify(header))
  }
  setUser(user) {
    this.globals.storagedUser = user;
    localStorage.setItem('user', JSON.stringify(user));
  }

  getUrlByKey(key) {
    switch (key) {
      case 1: {
        return '/operator'
      }
      case 2: {
        return '/customer'
      }
      case 3: {
        return '/documentary'
      }
      case 4: {
        return '/activity'
      }
      case 5: {
        return '/ticket'
      }
      case 6: {
        return '/contract'
      }
      case 7: {
        return '/group'
      }
      case 8:{
        return '/calendar'
      }
    }
  }
}